export class JobDescriptionKeys {
    public job_titles: string[] | string;
    public mandatory_job_titles: string[] | string;
    public skills: string[] | string;
    public mandatory_skills: string[] | string;
    public schools: string[] | string;
    public mandatory_schools: string[] | string;
    public locations: string[] | string;
    public mandatory_locations: string[] | string;
    public company_sizes: string[] | string;
    public mandatory_company_sizes: string[] | string;
    public companies: string[] | string;
    public mandatory_companies: string[] | string;
    public industries: string[] | string;
    public mandatory_industries: string[] | string;
    public degrees: string[] | string;
    public mandatory_degrees: string[] | string;
    public education_majors: string[] | string;
    public mandatory_education_majors: string[] | string;
    public fromYrsOfExperience: number;
    public toYrsOfExperience: number;

    constructor() {
        this.job_titles = [];
        this.mandatory_job_titles = [];
        this.skills = [];
        this.mandatory_skills = [];
        this.schools = [];
        this.mandatory_schools = [];
        this.locations = [];
        this.mandatory_locations = [];
        this.company_sizes = [];
        this.mandatory_company_sizes = [];
        this.companies = [];
        this.mandatory_companies = [];
        this.industries = [];
        this.mandatory_industries = [];
        this.degrees = [];
        this.mandatory_degrees = [];
        this.education_majors = [];
        this.mandatory_education_majors = [];
        this.fromYrsOfExperience = null;
        this.toYrsOfExperience = null;
    }
}
